import { initSentry } from "extensions/sentry";

import { store } from "common/store";

import { tracking } from "common/components/tracking";

export const DISABLE_PAGE_TRACKING = function() {
    store.dispatch({
        type: "config/DISABLE_PAGE_TRACKING"
    });
};

export const SET_APP_CONFIG = function(data) {
    const state = store.getState();
    store.dispatch({
        type: "config/SET_APP_CONFIG",
        data,
        overrideAPI: state.settings.overrideAPI === "default"
            ? false
            : state.settings.overrideAPI
    });
};

export const CONFIGURE_TRACKING = function() {
    if (["staging", "production"].includes(store.getState().config.env)) {
        tracking.addIntegration("PazienApiTracking");
        tracking.addIntegration("SessionTracker");
    }
    tracking.addIntegration("AppCues");
    tracking.addIntegration("Beamer");
};

export const INIT_SENTRY = function() {
    const state = store.getState();
    
    initSentry(state.config.sentry_key, {
        environment: state.config.env
    });
};

export const SET_API_VERSION = function(version) {
    store.dispatch({
        type: "config/SET_API_VERSION",
        data: version
    });
};

export function RESET_CONFIG_STORE() {
    store.dispatch({
        type: "config/RESET_CONFIG_STORE"
    });
}

export function ACCESS_DENIED({ code }) {
    store.dispatch({
        type: "config/ACCESS_DENIED",
        code
    });
}

export function ACCESS_GRANTED() {
    store.dispatch({
        type: "config/ACCESS_GRANTED"
    });
}

export function APP_READY() {
    if (store.getState().config.ready) return;
    
    store.dispatch({
        type: "config/APP_READY"
    });
}
